export default __webpack_public_path__ + "static/media/loading-200px.8becb139.svg";